/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";
import ODataStore from "devextreme/data/odata/store";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderNoteService = {
  dataSourceConfig(params) {
    var url = "api/SalesOrderNote";
    return ApiService.createDataSource(url, params);
  },

  async getNotesBySOCode(code) {

    const requestScreenData = {
      url: "api/SalesOrderNote",
      filter: `SalesOrderCode eq ${code}`,
      select: ["Note", "LineNo", "SalesOrderCode"],
      orderby: "LineNo asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  }
};



export { SalesOrderNoteService };
